import { render, staticRenderFns } from "./purchOrderDetail.vue?vue&type=template&id=04fa0741&scoped=true"
import script from "./purchOrderDetail.vue?vue&type=script&lang=js"
export * from "./purchOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./purchOrderDetail.vue?vue&type=style&index=0&id=04fa0741&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fa0741",
  null
  
)

export default component.exports